import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import * as actions from '../Actions.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';

export class FormDetailMovimentacoes extends Component {
  static propTypes = {
    pageMovimentacao: PropTypes.object.isRequired,
    findMovimentacao: PropTypes.func.isRequired,
    idEmenda: PropTypes.number.isRequired
  };

  componentDidMount() {
    this.searchWithPage(
      this.props.pageMovimentacao.set('number', 0).set('size', 20)
    );
  }

  searchWithPage = page => {
    const { findMovimentacao, idEmenda } = this.props;
    findMovimentacao(idEmenda, page);
  };

  renderRow = (movimentacao, index) => {
    return (
      <tr key={index}>
        <td>{DateUtils.formatDateTimeShort(movimentacao.get('data'))}</td>
        <td>{movimentacao.get('rotina')}</td>
        <td>{movimentacao.get('numeroDocumento')}</td>
        <td className="right">
          <NumberFormatter value={movimentacao.get('valor')} />
        </td>
      </tr>
    );
  };

  render() {
    const { pageMovimentacao } = this.props;
    const content = pageMovimentacao.get('content', List());

    return (
      <div>
        {content.size > 0 ? (
          <table className="panel-table striped fancy">
            <TableHeader empty={content.isEmpty()}>
              <tr>
                <th>Data</th>
                <th>Rotina</th>
                <th>Documento</th>
                <th style={{ textAlign: 'right' }}>Valor</th>
              </tr>
            </TableHeader>
            <tbody>{content.map(this.renderRow)}</tbody>
          </table>
        ) : (
          <div className="empty-state">Nenhuma movimentação encontrada.</div>
        )}
        <SearchPagination
          page={pageMovimentacao}
          searchWithPage={this.searchWithPage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageMovimentacao: state.emendaContabilidade.get('movimentacoes')
  };
}

const allActions = {
  findMovimentacao: actions.findMovimentacao
};

export default connect(mapStateToProps, allActions)(FormDetailMovimentacoes);
